// get percentage value from numerator and denominator
// if denominator is 0, output is 0 by default
export const getSafePercentage = (numerator: number, denominator: number): number => {
  return denominator === 0 ? 0 : Math.floor((numerator / denominator) * 100);
};

// replace curly braces placeholders in string wtih object properties
export const formatString = (str: string, format: { [key: string]: any; }): string => {
  return str.replace(
    /{\w+}/g,
    (placeholder) => {
      return format[placeholder.substring(1, placeholder.length - 1)]?.toString() || placeholder
    }
  );
};

export const formatNumberWithCommas = (n: number): string => {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
